import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleToIndex = () => {
		navigate('/', { replace: true });
	};

	return (
		<Box
			style={{
				textAlign: 'center',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%,-50%)',
			}}
		>
			<Box sx={{ margin: '80px 0 40px' }}>
				<Typography variant='h5' color={'#242628'} marginBottom={'24px'}>
					{t('common.systemError')}
				</Typography>
				<Typography variant='body1' color={'#76777A'}>
					{t('common.systemErrorMessage')}
				</Typography>
			</Box>
			<Button variant='contained' onClick={handleToIndex}>
				{t('button.toIndex')}
			</Button>
		</Box>
	);
};

export default ErrorPage;
